import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import Generator from "../pages/Generator";
import About from "../pages/About";
import LandingPage from "../pages/LandingPage";
import LogIn from "../pages/LandingPage/LogIn";
import PrivatePolicy from "../pages/Legal/PrivacyPolicy";
import TermsOfUse from "../pages/Legal/TermsOfUse";
import S2R from "../pages/S2R";
import AccountSettings from "../pages/Settings";
import Pricing from "../pages/Pricing";

import * as ROUTES from "./routes-const";

const Router = () => (
  <Switch>
    <Route path="/s2r">
      <S2R />
    </Route>
    <Route path="/settings">
      <AccountSettings />
    </Route>
    <Route path="/pricing">
      <Pricing />
    </Route>
    <Route path="/generator">
      <Generator />
    </Route>
    <Route path={ROUTES.ABOUT}>
      <About />
    </Route>
    <Route path="/privacy-policy">
      <PrivatePolicy />
    </Route>
    <Route path="/terms-of-use">
      <TermsOfUse />
    </Route>
    <Route path={ROUTES.LOGIN_PAGE}>
      <LogIn />
    </Route>
    <Route path={ROUTES.LANDING_PAGE}>
      <LandingPage />
    </Route>
    <Redirect to="/" />
  </Switch>
);

export default Router;
